import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import BookingModal from "@/components/site/BookingModal";
import {
  Hero,
  BeautyMarquee,
  Manifesto,
  Services,
  Offers,
  Packages,
  Gallery,
  Reviews,
  Contact,
  Footer,
} from "@/components/site/Sections";

export default function Landing() {
  const [data, setData] = useState({ offers: [], packages: [], reviews: [], gallery: [] });

  useEffect(() => {
    Promise.all([
      api.get("/offers"),
      api.get("/packages"),
      api.get("/reviews"),
      api.get("/gallery"),
    ])
      .then(([o, p, r, g]) =>
        setData({ offers: o.data, packages: p.data, reviews: r.data, gallery: g.data })
      )
      .catch(() => {});
  }, []);

  return (
    <div className="grain relative bg-[#FDFBF7]">
      <Navbar />
      <main>
        <Hero />
        <BeautyMarquee />
        <Manifesto />
        <Services />
        <Offers offers={data.offers} />
        <Packages packages={data.packages} />
        <Gallery gallery={data.gallery} />
        <Reviews reviews={data.reviews} />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
      <BookingModal />
    </div>
  );
}
